import type { AuthDto } from '@mathflat/domain/@entities/Auth'

import maxios from '@/utils/axios/maxios'

/***
 * @see res.Auth
 * @see AuthController
 ***/

// 인증 API
const authApi = {
  // 로그인
  postLogin(data: AuthDto.LoginRequestDto) {
    return maxios.post<AuthDto.LoginResponseDto>('/auth/login', data)
  },

  // [변경] /v2/logout → /auth/logout (새 프로젝트는 JWT 전용)
  postLogout(data: AuthDto.LogoutRequestDto) {
    return maxios.post('/auth/logout', data)
  },

  // [변경] /password/reset-token → /users/password-reset
  // 비밀번호 재설정 (1단계)
  postResetToken(data: req.FindPasswordFirstStep) {
    return maxios.post('/users/password-reset', data)
  },
  // [변경] /password/check-reset-token → /users/password-reset
  // 비밀번호 재설정 (2단계)
  getCheckResetToken(params: req.FindPasswordSecondStep) {
    return maxios.get('/users/password-reset', {
      params: { ...params },
    })
  },
  // [변경] PATCH /password/with-reset-token → PUT /users/password-reset
  // 비밀번호 재설정 (3단계)
  putCheckResetToken(data: req.FindPasswordThirdStep) {
    return maxios.put('/users/password-reset', data)
  },
  // [변경] POST /password → PUT /users/{userId}/password-change
  // 이미 로그인한 경우 패스워드 변경
  putPassword(userId: string, data: req.ResetPassword) {
    return maxios.put(`/users/${userId}/password-change`, data)
  },
  // [변경]   POST /password → POST /users/{userId}/password-reset
  // 기관 소유의 학생, 학부모, 선생님 비밀번호 변경
  postPassword(userId: string, data: req.ModifyAppPassword) {
    return maxios.post(`/users/${userId}/password-reset`, data)
  },
  // 서비스 이용 동의
  postAllowServiceType(data: { serviceType: string }) {
    return maxios.post('/teachers/service-types/access', data)
  },
}
export default authApi
